var _style, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNpm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#fff}")), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    d: "M67.5 178.8v121.9H169v20.5h81v-20.5h182.5V178.8z",
    style: {
      fill: "#cb3837"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    d: "M128.1 199.3H87.9v81h40.2v-60.6h20.4v60.6H169v-81z",
    className: "st1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    d: "M189.4 199.3v101.4h40.9v-20.4h40.2v-81zm60.6 60.6h-19.7v-40.2H250z",
    className: "st1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    d: "M331 199.3h-40.1v81H331v-60.6h20.5v60.6h20.4v-60.6h20.4v60.6h20.5v-81z",
    className: "st1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpm);
export default __webpack_public_path__ + "static/media/npm.0b813fc2861179d80f261a84656cab1b.svg";
export { ForwardRef as ReactComponent };